export type FulfillmentTaskKind = 'required' | 'optional' | 'linkup';
export type FulfillmentTaskStatus = 'pending' | 'satisfied';

export interface FulfillmentTask {
  readonly taskId: string;
  readonly lineId: string;
  readonly groupId: string;
  readonly label: string;
  readonly kind: FulfillmentTaskKind;
  readonly status: FulfillmentTaskStatus;
  readonly order: number;
}

export interface RequiredFlowSummary {
  readonly remaining: number;
  readonly canCheckout: boolean;
  readonly nextTask: FulfillmentTask | null;
  readonly pendingTaskIds: readonly string[];
}

const assertText = (value: string, code: string): void => {
  if (!value?.trim()) throw new Error(code);
};

export function summarizeRequiredFlow(tasks: readonly FulfillmentTask[]): RequiredFlowSummary {
  const seen = new Set<string>();
  for (const task of tasks) {
    assertText(task.taskId, 'REQUIRED_FLOW_TASK_ID_REQUIRED');
    assertText(task.lineId, 'REQUIRED_FLOW_LINE_ID_REQUIRED');
    assertText(task.groupId, 'REQUIRED_FLOW_GROUP_ID_REQUIRED');
    if (seen.has(task.taskId)) throw new Error('REQUIRED_FLOW_TASK_DUPLICATE');
    seen.add(task.taskId);
    if (!Number.isFinite(task.order)) throw new Error('REQUIRED_FLOW_TASK_ORDER_INVALID');
  }

  const pending = tasks
    .filter((task) => task.kind === 'required' && task.status === 'pending')
    .sort((left, right) => left.order - right.order || left.taskId.localeCompare(right.taskId));

  return {
    remaining: pending.length,
    canCheckout: pending.length === 0,
    nextTask: pending[0] ? { ...pending[0] } : null,
    pendingTaskIds: pending.map((task) => task.taskId),
  };
}
